let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h3oGY")).then(() => parcelRequire('1dCwS'));